// extracted by mini-css-extract-plugin
module.exports = {"anchor":"Heading_anchor__gIL2h","heading":"Heading_heading__PQx__"};